import React from 'react';
import styled, { StyledFunction } from 'styled-components';
import colors from '../../styles/colors';

export interface Props {
  isOn: boolean;
  onChange: () => void;
  disabled?: boolean;
  textPosition?: 'left' | 'right';
  activeText?: string;
  inactiveText?: string;
}

export interface ToggleProps {
  on: boolean;
  disabled?: boolean;
  activeText?: string;
  inactiveText?: string;
}

const styledDiv: StyledFunction<
  ToggleProps & React.HTMLProps<HTMLInputElement>
> = styled.div;

class SimpleToggle extends React.Component<Props, any> {
  static defaultProps = { textPosition: 'right' };

  render() {
    const {
      isOn,
      onChange,
      disabled,
      activeText,
      inactiveText,
      textPosition,
    } = this.props;

    const toggleText = () => {
      const text = isOn ? activeText : inactiveText;
      return (
        !!text && (
          <ToggleText data-testid="toggle-text" on={isOn} disabled={disabled}>
            {text}
          </ToggleText>
        )
      );
    };

    return (
      <ToggleContainer
        disabled={disabled}
        onClick={!disabled ? onChange : () => {}}
      >
        {textPosition === 'left' && toggleText()}
        <ToggleFrame
          data-testid="toggle-frame"
          on={isOn}
          disabled={disabled}
          // tslint:disable-next-line:no-empty
        >
          <SwitchToggle on={isOn} data-testid="toggle-switch" />
        </ToggleFrame>
        {textPosition === 'right' && toggleText()}
      </ToggleContainer>
    );
  }
}

const ToggleContainer = styled.div`
  display: flex;
  align-content: center;
  cursor: pointer;
  ${props => props.disabled && 'cursor: not-allowed;'}
`;

const getColorValue = (props: ToggleProps) => {
  if (!!props.disabled) {
    return colors.grey400;
  } else {
    return props.on ? colors.green500 : colors.grey800;
  }
};

const ToggleFrame = styledDiv`
  width: 40px;
  height: 22px;
  border-radius: 11px;
  align-self: flex-start;
  display: inline-block;
  background: ${getColorValue};
`;

const SwitchToggle = styledDiv`
  width: 16px;
  height: 16px;
  left: 3px;
  top: 3px;
  border-radius: 8px;
  background: white;
  position: relative;
  transition: left 0.1s ease-in-out;
  ${props => props.on && 'left: 21px;'};
`;

const ToggleText = styledDiv`
  margin: 0 0.6rem;
  font-size: 14px;
  color: ${getColorValue};
  user-select: none;
`;

export default SimpleToggle;
